var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[_c('div',{staticClass:"icon-wrapper"},[_c('Icon',{attrs:{"type":"icon-img_kongxiangzi"}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1),_vm._m(0),_c('p',{staticClass:"link"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.goBack}},[_vm._v("返回上级菜单")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"link"},[_c('a',{attrs:{"href":"/"}},[_vm._v("返回首页")])])
}]

export { render, staticRenderFns }